/**
 * CardThumb — 카드 아트워크 썸네일 (공유).
 *
 * 왜 뽑았나: 같은 마크업이 홈·컬렉션 목록·컬렉션 상세·카드 피커 네 곳에 복제돼
 * 있었고, 그중 셋은 **CollectionsPage.module.css 를 가로질러 import** 하고 있었다
 * (페이지가 다른 페이지의 스타일을 쓰면 한쪽을 고칠 때 나머지가 조용히 바뀐다).
 *
 * 이미지는 카드 객체가 들고 온다 (`DummyCard.imgUrl`). **지금은 임시 더미다** —
 * 실 CDN 이 붙으면 dummyCards 의 그 필드만 서버 URL 로 갈아끼우면 되고 여기는
 * 그대로다.
 *
 * ⚠ 이미지가 없거나 못 뜨면 colorKey 그라디언트로 떨어진다. 아무것도 안 그리면
 *   카드가 아니라 빈 칸으로 읽힌다 — 그래서 그라디언트를 지우지 않고 **배경으로
 *   깔아 둔 채** 그 위에 이미지를 얹는다.
 *
 * 폭은 두 가지뿐이다:
 *   row  — 목록 행(List/Item startContent). --size-thumb 고정폭
 *   fill — 그리드 셀·캐러셀 타일. 부모 폭을 채운다
 * 비율(63:88)과 각진 모서리는 두 변형이 공유한다.
 */
import { CARD_GRADIENTS } from "../../data/dummyCards";
import styles from "./CardThumb.module.css";

export type CardThumbSize = "row" | "fill";

export interface CardThumbProps {
  /**
   * dummyCards 의 colorKey — 이미지가 없을 때 깔리는 CARD_GRADIENTS 조회에 쓴다.
   * 실 카탈로그 카드에는 이 축이 없다 — 그때는 중립 플레이스홀더(.base 기본 배경)로 떨어진다.
   */
  colorKey?: string;
  /** 카드 아트워크. 없으면 그라디언트만 보인다 */
  imgUrl?: string;
  /** @default "row" */
  size?: CardThumbSize;
  /**
   * 스크린리더용 이름. 카드명이 옆에 이미 있으면 생략한다 —
   * 그 경우 장식이므로 aria-hidden 으로 빠진다.
   */
  ariaLabel?: string;
}

export default function CardThumb({
  colorKey,
  imgUrl,
  size = "row",
  ariaLabel,
}: CardThumbProps) {
  return (
    <span
      className={`${styles.base} ${size === "fill" ? styles.fill : styles.row}`}
      style={colorKey ? { background: CARD_GRADIENTS[colorKey] } : undefined}
      role={ariaLabel ? "img" : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    >
      {imgUrl && (
        /* alt 는 늘 비운다 — 이름은 바깥 span 의 aria-label 이 말하거나, 옆의
           카드명이 말한다. 여기서 또 읽으면 같은 이름이 두 번 들린다. */
        <img className={styles.art} src={imgUrl} alt="" loading="lazy" decoding="async" />
      )}
    </span>
  );
}
